const V3_RELEASE_DATE = 20210513;
const V3_2_RELEASE_DATE = 20241115;

export function getFirmwareGeneration(firmwareVersion) {
  const match = /^(\d{8})/.exec(String(firmwareVersion).trim());
  if (!match) {
    return null;
  }

  const releaseDate = Number(match[1]);
  if (releaseDate < V3_RELEASE_DATE) {
    return 'v2';
  }
  if (releaseDate < V3_2_RELEASE_DATE) {
    return 'v3';
  }
  if (releaseDate === V3_2_RELEASE_DATE) {
    return 'v3.2';
  }
  return 'v3.2+';
}

export function formatFirmwareVersion(firmwareVersion) {
  if (!firmwareVersion) {
    return 'none';
  }
  return getFirmwareGeneration(firmwareVersion) || String(firmwareVersion);
}
